/**
 * @Description 操作动态路由文件
 * @author 滕威
 * @time 2019-12-02
 */
import router from "../router/router";
import { supervisionRouteMap } from "../router/index";
import { fun_GetAction } from "@/api";
import store from "../store";
// const _import = require("../router/_import_" + process.env.NODE_ENV); //获取组件的方法
import Layout from "../views/layout/Home"; //Layout 是架构组件，不在后台返回，在文件里单独引入
import { Message } from "element-ui";

let getRouter; //用来获取后台拿到的路由
let otherRouters = []; // 用来存储详情路由
router.beforeEach((to, from, next) => {
  // 全局进行错误拦截
  // 解决路由抛出的异常Uncaught (in promise) undefined
  // 主要是因为router3.1.0+在使用this.$router.push时返回了promise，需要特殊处理，否则加载router时会自动抛出异常
  const routerMethods = ["push", "replace"];
  routerMethods.forEach(method => {
    const originalCall = router[method];
    router[method] = function(location, onResolve, onReject) {
      if (onResolve || onReject) {
        return originalCall.call(this, location, onResolve, onReject);
      }
      return originalCall.call(this, location).catch(err => err);
    };
  });
  if (to.name == "login" || to.name == "workerLogin") {
    // 记录登录类型
    let loginType = sessionStorage.getItem("loginType");
    // 清空sessionStorage
    sessionStorage.clear();
    // 重置
    if (loginType) sessionStorage.setItem("loginType", loginType);
    getRouter = false;
  }
  if (!getRouter && sessionStorage.getItem("ebd_token")) {
    //不加这个判断，路由会陷入死循环
    if (!sessionStorage.getItem("router")) {
      // 如果是工作人员登录
      if(sessionStorage.getItem("userFlag") == "工作人员" || sessionStorage.getItem("userFlag") == "监管人员"){
        fun_GetAction("/supervisorPower/supervisorFindMenu").then(res => {
          const { result, data, msg } = res.data;
          if (result) {
            getRouter = data.router; //假装模拟后台请求得到的路由数据
            const userInfo = {
              realName: data.zsxm,
            };
            store.commit("SET_USERINFO", userInfo); // 存储路由到vuex
            store.commit("SET_ROUTER", getRouter); // 存储路由到vuex
            routerGo(to, next, getRouter); //执行路由跳转方法
          } else {
            Message.error(msg);
          }
        });
      }
      else{
        // 如果是注册人员
        if(sessionStorage.getItem("userType") === "201508061647510026"){
          fun_GetAction("/findPower/registryFindMenu").then(res => {
            const { result, data, msg } = res.data;
            if (result) {
              getRouter = data.opList; //假装模拟后台请求得到的路由数据
              const userInfo = {
                realName: data.realName,
                username: data.username,
                userId: data.userId
              };
              store.commit("SET_USERINFO", userInfo); // 身份信息存储到vuex
              store.commit("SET_ROUTER", getRouter); // 存储路由存储到vuex
              routerGo(to, next, getRouter); //执行路由跳转方法
            } else {
              Message.error(msg);
            }
          });
        }
        // 如果是交易人
        else{
          fun_GetAction("/findPower/operationFindMenu?type=" + sessionStorage.getItem("loginType")).then(res => {
            const { result, data, msg } = res.data;
            if (result) {
              getRouter = data.router; //假装模拟后台请求得到的路由数据
              const userInfo = {
                realName: data.realName,
                username: data.username,
                userId: data.userId
              };
              store.commit("SET_USERINFO", userInfo); // 存储路由到vuex
              store.commit("SET_ROUTER", getRouter); // 存储路由到vuex
              routerGo(to, next, getRouter); //执行路由跳转方法
            } else {
              Message.error(msg);
            }
          });
        }
      }
    } else {
      //从sessionStorage拿到了路由
      getRouter = JSON.parse(sessionStorage.getItem("router"));
      routerGo(to, next, getRouter);
    }
  } else {
    next();
  }
});

function routerGo(to, next, routerJson) {
  filterOtherRouter(routerJson);
  let asyncRouters = filterAsyncRouter(routerJson);
  const errorRouter = [
    {
      path: "/404",
      name: "exception404",
      component: () => import("../components/exception/404")
    },
    {
      path: "/403",
      name: "exception403",
      component: () => import("../components/exception/403")
    },
    {
      path: "/500",
      name: "exception500",
      component: () => import("../components/exception/500")
    }
  ];
  const localouter = [
    // 工作台详情
    {
      path: "/workbenchDetails",
      name: "workbenchDetails",
      component: () => import("../views/page/workbench/details/index.vue")
    },
    // 修改密码
    {
      path: "/password",
      name: "password",
      component: () => import("../views/page/userRegister/updatePassword/index.vue")
    },
    // 修改密码
    {
      path: "/loginPassword",
      name: "loginPassword",
      component: () => import("../views/page/corpView/loginPassword/index.vue")
    },
    // 消息提醒
    {
      path: "/workbenchMore",
      name: "workbenchMore",
      component: () => import("../views/page/workbench/components/more/index.vue")
    },
    // 交易人 - 用户注册模块
    {
      path: "/userRegister",
      name: "userRegister",
      component: () => import("../views/page/userRegister/index.vue")
    },
    // 网上CA资料申报信息
    {
      path: "/userDeclare",
      name: "userDeclare",
      component: () => import("../views/page/userRegister/declare/index.vue")
    },
    // 监管人员路由
    ...supervisionRouteMap
  ];
  const homeRouter = [
    {
      path: "/home",
      name: "home",
      component: () => import("../views/layout/Home"),
      // redirect: { path: "/userManage" },
      children: [...otherRouters, ...localouter, ...errorRouter]
    }
  ];
  router.addRoutes(homeRouter); //动态添加路由
  router.addRoutes(asyncRouters); //动态添加路由
  global.antRouter = asyncRouters; //将路由数据传递给全局变量，做侧边栏菜单渲染工作
  next({
    ...to,
    replace: true
  });
}

function filterAsyncRouter(asyncRouterMap) {
  //遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      if (route.component === "Layout") {
        //Layout组件特殊处理
        route.component = Layout;
      } else {
        route.component = componentImport(route.component);
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children);
    }
    return true;
  });
  return accessedRouters;
}

function filterOtherRouter(asyncRouterMap) {
  for (let i in asyncRouterMap) {
    let otherRouter = {};
    if (asyncRouterMap[i].component) {
      if (asyncRouterMap[i].component === "Layout") {
        //Layout组件特殊处理
      } else {
        otherRouter.name = asyncRouterMap[i].name.replace(
            asyncRouterMap[i].name,
            asyncRouterMap[i].name + "Detail"
        );
        otherRouter.path = asyncRouterMap[i].path.replace(
            asyncRouterMap[i].path,
            asyncRouterMap[i].path + "Detail"
        );
        otherRouter.meta = {};
        if (asyncRouterMap[i].title != "") {
          otherRouter.title = asyncRouterMap[i].title + "详情";
          otherRouter.component = componentImport(
              asyncRouterMap[i].component.replace(
                  asyncRouterMap[i].path.replace("Ebd", ""),
                  asyncRouterMap[i].path.replace("Ebd", "") + "/details"
              )
          );
        }
      }
    }
    if (otherRouter.name) {
      otherRouters.push(otherRouter);
    }
    if (asyncRouterMap[i].children && asyncRouterMap[i].children.length) {
      asyncRouterMap[i].children = filterOtherRouter(
          asyncRouterMap[i].children
      );
    }
  }
  return asyncRouterMap;
}

function componentImport(component) {
  return () => import("../views/" + component);
}
